import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

function CartItemSkeleton() {
  return (
    <>
      <Box display={"flex"} flexDirection={"row"} gap={3} sx={{ mt: 2}}>
        <Skeleton
          variant="rectangular"
          width={"120px"}
          height="100px"
          sx={{ borderRadius: 1 }}
        />

        <Box
          sx={{
            gap: 1,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Skeleton
            variant="text"
            width={"40%"}
            height="35px"
            sx={{ borderRadius: 1 }}
          />

          <Box sx={{ display: "flex", flexDirection: "row", gap: 3 }}>
            <Skeleton
              variant="text"
              width={"10%"}
              height="24px"
              sx={{ borderRadius: 1 }}
            />
            <Skeleton
              variant="text"
              width={"10%"}
              height="24px"
              sx={{ borderRadius: 1 }}
            />
          </Box>

          <Stack direction="row" spacing={2} alignItems={"center"}>
            <Skeleton
              variant="text"
              width={"20%"}
              height="30px"
              sx={{ borderRadius: 1 }}
            />
          </Stack>
        </Box>
      </Box>
    </>
  );
}

export default CartItemSkeleton;
